import React from 'react'
import './styles.scss'
import PluginSharedFiles from './PluginSharedFiles'
import { useSelector } from 'react-redux'
import { getStaticImage } from 'utils/statics'
import PluginContactInformation from './PluginContactInformation'

const InChatPlugins = ({ isOpen, toggle }) => {
  const { tabs, inchat } = useSelector(state => state)
  const { activeUser } = tabs
  const { isOpenThreads, conversations } = inchat
  const conversation = conversations[activeUser]?.conversation

  return (
    <div className={`
      inchat-plugins
      ${!isOpen ? 'inchat-plugins--closed' : ''}
    `}>
      <button
        className={`
        inchat-plugins__toggle-panel
          ${!isOpen ? 'inchat-plugins__toggle-panel--closed' : ''}
        `}
        onClick={toggle}
      >
        <figure>
          <img src={getStaticImage('/icons/orange-brand/icon-arrow-back-dark.svg')} alt='Arrow Panel' />
        </figure>
      </button>
      <div className='inchat-plugins__container'>
        <PluginContactInformation conversation={conversation} />
        <PluginSharedFiles
          id={'shared_files'}
          conversationId={activeUser}
          isThread={isOpenThreads}
        />
      </div>
    </div>
  )
}

export default InChatPlugins